/* Cristal Kitchen - "Avisame cuando llegue"
 *
 * En los productos sin stock el boton "Agotado" no hace nada: el visitante
 * llega, no puede comprar y se va sin dejar rastro. Este script lo reemplaza
 * por un enlace a WhatsApp con el mensaje ya escrito, asi capturamos el
 * contacto y medimos demanda real sin cobrarle a nadie por adelantado.
 *
 * No toca nada en los productos CON stock.
 * Para desactivarlo: borra la linea que carga este archivo en
 * snippets/meta-tags.liquid
 */
(function () {
  var WHATSAPP = '59891209773'; // 091 209 773 en formato internacional

  function tituloDelProducto() {
    var sel = ['.product__title h1', '.product__title', 'h1.product__title', 'main h1'];
    for (var i = 0; i < sel.length; i++) {
      var el = document.querySelector(sel[i]);
      if (el && el.innerText.trim()) return el.innerText.trim();
    }
    return document.title.split('–')[0].trim();
  }

  function aplicar() {
    var cont = document.querySelector('.product__info-container');
    if (!cont) return; // no estamos en una pagina de producto

    var btn = cont.querySelector('button[name="add"], .product-form__submit');
    if (!btn) return;

    var wrap = btn.closest('.product-form__buttons') || btn.parentElement;
    var yaEsta = wrap.querySelector('.ck-avisame');

    if (!btn.disabled) {
      // Hay stock: dejamos todo como viene.
      if (yaEsta) {
        yaEsta.remove();
        var n = wrap.querySelector('.ck-avisame-nota');
        if (n) n.remove();
        btn.style.removeProperty('display');
        var p = wrap.querySelector('.shopify-payment-button');
        if (p) p.style.removeProperty('display');
      }
      return;
    }

    if (yaEsta) return; // ya lo pusimos

    var msg = 'Hola! Vi el ' + tituloDelProducto() +
              ' en la web y esta sin stock. Me avisan cuando vuelva?';

    var a = document.createElement('a');
    a.className = 'ck-avisame';
    a.href = 'https://wa.me/' + WHATSAPP + '?text=' + encodeURIComponent(msg);
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.textContent = 'Avisame cuando llegue';

    var nota = document.createElement('p');
    nota.className = 'ck-avisame-nota';
    nota.textContent = 'Sin stock por ahora. Te escribimos apenas entre.';

    btn.style.display = 'none';
    var pago = wrap.querySelector('.shopify-payment-button');
    if (pago) pago.style.display = 'none';

    wrap.appendChild(a);
    wrap.appendChild(nota);
  }

  function iniciar() {
    aplicar();
    // El tema redibuja el boton al cambiar de variante (2.5L, 3.5L...),
    // asi que observamos el contenedor y reaplicamos.
    var cont = document.querySelector('.product__info-container');
    if (!cont || !window.MutationObserver) return;
    var pendiente = false;
    new MutationObserver(function () {
      if (pendiente) return;
      pendiente = true;
      setTimeout(function () { pendiente = false; aplicar(); }, 60);
    }).observe(cont, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar, { once: true });
  } else {
    iniciar();
  }
})();
